namespace $.$$ {

	$mol_style_define( $shm_tests_release, {

		Overview: {
			flex: {
				basis: '28rem',
			},
		},

		History: {
			flex: {
				basis: '36rem',
				grow: 1,
			},
		},

		Channels: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
			padding: $mol_gap.block,
		},

		Release: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			border: {
				bottom: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Release_title: {
			font: {
				weight: 'bold',
			},
		},

		Release_meta: {
			color: $mol_theme.shade,
		},

	} )

}
